import { axiosInterceptorInstance } from 'api'

export const notificationsApi = {
  list: () => axiosInterceptorInstance.get(`/notification/list`),

  latestList: () => axiosInterceptorInstance.get(`/notification/latest/list`),

  markRead: (id) => axiosInterceptorInstance.post(`/notification/read/${id}`),

  markAllRead: () => axiosInterceptorInstance.post(`/notification/all/read`),

  send: (payload) =>
    axiosInterceptorInstance.post(
      '/push/notification/send-notifications',
      payload,
    ),

  storeFcmToken: (token) =>
    axiosInterceptorInstance.post(`/push/notification/store/token`, { token }),
}
